{{ title }}:&nbsp; @if (fileInput.files[0]) {
<ng-container>[{{ fileInput.files[0].name }}]&nbsp;</ng-container>
}
<a (click)="fileInput.click()">{{ 'FUEL.UPLOAD' | translate }}</a>
<input #fileInput type="file" hidden />
